var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3L8 3V6.25C8 6.49025 8.30585 6.5922 8.45 6.4L9.5 5L10.55 6.4C10.6942 6.5922 11 6.49025 11 6.25V3C11.5523 3 12 3.44772 12 4V8H5C4.64936 8 4.31278 8.06015 4 8.17071V4C4 3.44772 4.44772 3 5 3ZM2 11V4C2 2.34315 3.34315 1 5 1H11C12.6569 1 14 2.34315 14 4V9V12C14 13.6569 12.6569 15 11 15H5C3.34315 15 2 13.6569 2 12V11ZM12 12C12 12.5523 11.5523 13 11 13H5C4.44772 13 4 12.5523 4 12V11C4 10.4477 4.44772 10 5 10H12V11H5.5C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12H12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.033c9fc9c51ffb68fc348ae2efea86f4.svg";
export { ForwardRef as ReactComponent };